import { Loader2 } from 'lucide-react'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const Spinner = ({ size = 'md', className = '' }: SpinnerProps) => {
  const sizes: Record<string, string> = { sm: 'h-4 w-4', md: 'h-8 w-8', lg: 'h-12 w-12' }
  return <Loader2 className={`animate-spin text-primary-500 ${sizes[size]} ${className}`} />
}

Spinner.Page = () => (
  <div className="flex min-h-screen items-center justify-center bg-background-primary"><Spinner size="lg" /></div>
)

Spinner.Center = ({ className = '' }: { className?: string }) => (
  <div className={`flex items-center justify-center py-12 ${className}`}><Spinner /></div>
)

export default Spinner
